module.exports = __webpack_public_path__ + "img/title.9b7ca77b.png";